import React, { useEffect, useState } from "react";
import { UserPlus, Trash2, Power } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";

export default function Admins() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const load = () => api.get("/admin/admins").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!email.trim()) { toast.error("Enter an email."); return; }
    try { await api.post("/admin/admins", { email, name }); toast.success("Administrator added."); setEmail(""); setName(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed."); }
  };
  const toggle = async (a) => {
    try { await api.patch(`/admin/admins/${encodeURIComponent(a.email)}`, { active: !a.active }); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed."); }
  };
  const remove = async (a) => {
    try { await api.delete(`/admin/admins/${encodeURIComponent(a.email)}`); toast.success("Removed."); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed."); }
  };

  return (
    <div data-testid="admins-page">
      <div className="overline mb-2">Access Control</div>
      <h1 className="font-serif text-4xl text-oxford tracking-tight">Administrators</h1>
      <p className="text-[var(--text2)] mt-2">Authorized Google accounts that may access this console.</p>

      <div className="bg-white border border-[var(--brdr)] rounded-sm p-6 shadow-sm mt-8">
        <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-4 items-end">
          <div>
            <label className="overline">Email</label>
            <Input data-testid="new-admin-email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="name@gmail.com" className="mt-1.5 h-11 bg-white border-[var(--brdr)]" />
          </div>
          <div>
            <label className="overline">Name (optional)</label>
            <Input data-testid="new-admin-name" value={name} onChange={(e) => setName(e.target.value)}
              className="mt-1.5 h-11 bg-white border-[var(--brdr)]" />
          </div>
          <Button data-testid="add-admin-btn" onClick={add} className="btn-primary text-white h-11 px-6">
            <UserPlus className="mr-2 h-4 w-4" /> Add
          </Button>
        </div>
      </div>

      <div className="bg-white border border-[var(--brdr)] rounded-sm shadow-sm mt-6 divide-y divide-[var(--brdr)]">
        {list.map((a) => (
          <div key={a.email} data-testid={`admin-row-${a.email}`} className="px-6 py-4 flex items-center justify-between">
            <div>
              <div className="text-sm font-medium text-oxford flex items-center gap-2">
                {a.name || a.email}
                {a.email === user?.email && <span className="text-[10px] uppercase tracking-wider text-gold">You</span>}
              </div>
              <div className="text-xs text-[var(--text2)]">{a.email} · added by {a.added_by}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className={`text-xs rounded-full px-3 py-0.5 border ${a.active ? "bg-green-50 text-[var(--success)] border-green-200" : "bg-gray-50 text-[var(--text2)] border-gray-200"}`}>
                {a.active ? "Active" : "Inactive"}
              </span>
              <button data-testid={`toggle-admin-${a.email}`} onClick={() => toggle(a)}
                className="text-[var(--text2)] hover:text-oxford p-2" title="Toggle active"><Power className="h-4 w-4" /></button>
              <button data-testid={`remove-admin-${a.email}`} onClick={() => remove(a)}
                className="text-[var(--text2)] hover:text-[var(--danger)] p-2" title="Remove"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
